import MdaeDataGridActionEllipsis, {
  getDataGridActionEllipsisComponent,
} from "./component";
export interface IDataGridActionEllipsisProps {
  buttonId?: string;
  divId?: string;
  cellInfo?: any;
  onClick?: Function;
  className?: string;
}
interface IMdaeActionEllipsisOtherConfigsCommon{
  entityId: number | string;
  entityName: string;
  showActionPopover: (isVisible: boolean, className: string, otherConfig: any) => void
  currentRowData: any;
}
export interface IMdaeActionEllipsisOtherConfigsWithoutDispatch extends IMdaeActionEllipsisOtherConfigsCommon{
  type: "withoutDispatch";
  currentRowDataUpdater: (currentRowData: any) => void
}
export interface IMdaeActionEllipsisOtherConfigsWithDispatch extends IMdaeActionEllipsisOtherConfigsCommon{
  type: "usingDispatch";
  dispatch: any
}

export { getDataGridActionEllipsisComponent };

export default MdaeDataGridActionEllipsis;
